import React, { useState } from 'react';
import { Building2, TrendingDown, Zap, Heart, Layers, Sliders, FileText, Link2, Rocket } from 'lucide-react';
import AudienceLayout from './AudienceLayout';
import RegistrationModal from '../../components/RegistrationModal';

const ForCompanyPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <>
      <AudienceLayout
        color="blue"
        Icon={Building2}
        eyebrow="VITAL PARA SUA EMPRESA"
        title="Transforme a saúde dos seus colaboradores em um diferencial competitivo."
        subtitle="A Vital Performance conecta empresas aos melhores centros de treinamento da região por meio de uma plataforma inteligente que reduz o absenteísmo, melhora a qualidade de vida e aumenta a produtividade."
        heroImage="https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80"
        onPrimary={() => setModalOpen(true)}
        onSecondary={() => document.querySelector('[data-testid="for-company-how-it-works"]')?.scrollIntoView({ behavior: 'smooth' })}
        testIdPrefix="for-company"
        steps={[
          { title: 'Empresa cria a conta', desc: 'Cadastro em minutos com CNPJ e dados corporativos' },
          { title: 'Cadastra os colaboradores', desc: 'Individualmente ou em lote via planilha' },
          { title: 'Escolhe o subsídio', desc: 'Defina quanto quer custear do benefício' },
          { title: 'Colaboradores escolhem academia', desc: 'Rede parceira com dezenas de opções' },
          { title: 'RH acompanha em tempo real', desc: 'Painel com indicadores e utilização' },
        ]}
        benefits={[
          { icon: TrendingDown, title: 'Redução do absenteísmo', desc: 'Colaboradores mais saudáveis faltam menos' },
          { icon: Zap, title: 'Mais produtividade', desc: 'Energia e foco durante o expediente' },
          { icon: Heart, title: 'Incentivo ao bem-estar', desc: 'Cultura de saúde interna' },
          { icon: Layers, title: 'Gestão centralizada', desc: 'Tudo em um único painel' },
          { icon: Sliders, title: 'Benefício flexível', desc: 'Cada colaborador escolhe onde treinar' },
          { icon: FileText, title: 'Relatórios para RH', desc: 'Métricas de uso e engajamento' },
          { icon: Link2, title: 'Rede de academias', desc: 'Parcerias já ativas na sua região' },
          { icon: Rocket, title: 'Fácil implantação', desc: 'Ativação em até 48 horas' },
        ]}
        differentials={[
          'Plataforma exclusiva desenvolvida para empresas brasileiras',
          'Rede de academias parceiras em constante expansão',
          'Controle total sobre utilização do benefício',
          'Check-in inteligente por QR Code ou catraca',
          'Gestão corporativa com múltiplos setores',
          'Melhor custo-benefício do mercado',
        ]}
        finalCtaTitle="Sua empresa pronta para investir em saúde corporativa."
        finalCtaSubtitle="Crie sua conta agora e nossa equipe entrará em contato para uma demonstração personalizada."
      />
      <RegistrationModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        initialProfile="company"
      />
    </>
  );
};

export default ForCompanyPage;
